import axios from "axios";
import { toast } from "react-toastify";
import { SERVER_BASE_URL } from "../../constants/constants";
// import Client from "../ClientSocket";
import { LocalStorage } from "../LocalStorage";

export interface LoginForm {
    email: string,
    password: string
}


export const AuthenticationService = {

    /**
     * Sends user creation request to server.
     * @param email
     * @param username 
     * @param password 
     */
    async signUp(email: string, name: string, firstname:string, password: string) {
        const content = { email: email, name: name, firstname:firstname, password: password };
        return axios.post(`${SERVER_BASE_URL}api/auth/signup`, content)
            .then(res => {
                console.log(res)
                if (res.status === 201) {
                    toast.info("Compte créé avec succès!");
                    return true
                }else{
                    return false
                }
            })
            .catch(err => {
                console.log(err)
                if (err.response.data) {
                    toast.error(err.response.data);
                }
                return false
            })
    },

    async forgot(email: string) {
        const content = { email: email};
        return axios.post(`${SERVER_BASE_URL}api/auth/forgot-password`, content)
            .then(res => {
                window.location.href = '/login'
            })
            .catch(err => {
                console.log(err)
                if (err.response.data) {
                    toast.error(err.response.data);
                }
                return false
            })
    },

    login(form: LoginForm, successFn: (token: string, role: string, userId: string, hasReadConsent:boolean, survey:any, server:string, store:string) => void) {
        console.log(`[AuthenticationService] ========== LOGIN REQUEST ==========`);
        console.log(`[AuthenticationService] Server URL:`, SERVER_BASE_URL);
        console.log(`[AuthenticationService] Login form:`, form);
        console.log(`[AuthenticationService] Full URL:`, `${SERVER_BASE_URL}api/auth/login`);
        
        axios.put(`${SERVER_BASE_URL}api/auth/login`, form)
            .then(res => {
                console.log(`[AuthenticationService] ========== LOGIN RESPONSE ==========`);
                console.log(`[AuthenticationService] Response status:`, res.status);
                console.log(`[AuthenticationService] Response data:`, res.data);
                console.log(`[AuthenticationService] Response payload:`, res.data?.payload);
                
                if (res.data.payload) {
                    const token = res.data.payload.token;
                    const role = res.data.payload.role;
                    const userId = res.data.payload.id;
                    const hasReadConsent = res.data.payload.has_read_consent;
                    const survey = res.data.payload.survey;
                    const server = res.data.payload.server;
                    const store = res.data.payload.store;
                    
                    console.log(`[AuthenticationService] Extracted token:`, token);
                    console.log(`[AuthenticationService] Extracted role:`, role);
                    console.log(`[AuthenticationService] Extracted userId:`, userId);
                    console.log(`[AuthenticationService] Extracted hasReadConsent:`, hasReadConsent);
                    console.log(`[AuthenticationService] Extracted survey:`, survey);
                    console.log(`[AuthenticationService] Extracted server:`, server);
                    console.log(`[AuthenticationService] Token type:`, typeof token);
                    
                    
                    if (typeof token === "string") { 
                        console.log(`[AuthenticationService] Calling success callback`);
                        successFn(token, role, userId, hasReadConsent, survey, server, store); 
                    } else {
                        console.error(`[AuthenticationService] ERROR: Token is not a string!`);
                    }
                } else {
                    console.error(`[AuthenticationService] ERROR: No payload in response!`);
                }
            })
            .catch(err => {
                console.error(`[AuthenticationService] ========== LOGIN ERROR ==========`);
                console.error(`[AuthenticationService] Error:`, err);
                console.error(`[AuthenticationService] Error response:`, err.response);
                console.error(`[AuthenticationService] Error response data:`, err.response?.data);
                console.error(`[AuthenticationService] Error response status:`, err.response?.status);
                
                if (err.response.data) {
                    toast.error(err.response.data)
                }
            })
    }
};